const TOKEN_KEY = "TOKEN_KEY";
const USERNAME = "USERNAME";
const NAME = "NAME";
const ROLE = "ROLE";
const EXPIRED_TOKEN_TIME = 1;
import { ROLE_HEAD, ROLE_PLAN } from "@/common/constant.js";
import Cookies from "js-cookie";

// TOKEN

export const saveToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: EXPIRED_TOKEN_TIME });
};

export const getToken = () => {
  return Cookies.get(TOKEN_KEY) || "";
};

export const destroyToken = () => {
  Cookies.remove(TOKEN_KEY);
};

// USERNAME

export const saveUsername = (username) => {
  Cookies.set(USERNAME, username, { expires: EXPIRED_TOKEN_TIME });
};

export const getUsername = () => {
  return Cookies.get(USERNAME);
};

export const destroyUsername = () => {
  Cookies.remove(USERNAME);
};

// NAME

export const saveName = (name) => {
  Cookies.set(NAME, name, { expires: EXPIRED_TOKEN_TIME });
};

export const getName = () => {
  return Cookies.get(NAME);
};

export const destroyName = () => {
  Cookies.remove(NAME);
};

// ROLE
export const saveRole = (role) => {
  Cookies.set(ROLE, JSON.stringify(role), { expires: EXPIRED_TOKEN_TIME });
};

export const getRole = () => {
  return JSON.parse(decodeURIComponent(Cookies.get(ROLE)));
};

export const destroyRole = () => {
  Cookies.remove(ROLE);
};

export const isHead = () => {
  return vx.state.auth.permissions.includes(ROLE_HEAD.roleCode);
};

export const isPlan = () => {
  return vx.state.auth.permissions.includes(ROLE_PLAN.roleCode);
};

export const isLogged = () => {
  return !!getToken() && !!getUsername() && !!getName() && !!getRole();
};

export default {
  saveToken,
  getToken,
  destroyToken,
  saveUsername,
  getUsername,
  destroyUsername,
  saveName,
  getName,
  destroyName,
  saveRole,
  getRole,
  destroyRole,
  isLogged,
  isHead,
  isPlan,
};
